/** @format */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

import I18n from '../../../components/Translate/I18n';
import Button from '@material-ui/core/Button';
import ClientAddressEdit from './ClientAddressEdit';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import i18n from '../../../core/i18n';

class ClientAddressesDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabValue: 0,
        };
    }

    saveChild = () => {
        this.child.saveElement();
    };

    handleChange = (event, tabValue) => {
        this.setState({ tabValue });
    };

    render() {
        const { tabValue } = this.state;
        const { open, callBackClose, classes, clientId } = this.props;

        return (
            <Dialog
                fullWidth={true}
                maxWidth="sm"
                open={open}
                keepMounted
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title" style={{ padding: '0 0 0 0' }}>
                    <AppBar position="static">
                        <Tabs
                            value={tabValue}
                            onChange={this.handleChange}
                            variant="fullWidth"
                            indicatorColor="primary"
                            textColor="primary"
                            style={{ backgroundColor: 'white' }}
                        >
                            <Tab label={i18n.t('clients:a.address_type1')} />
                            <Tab label={i18n.t('clients:a.address_type2')} />
                        </Tabs>
                    </AppBar>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" />
                    <GridContainer>
                        <GridItem xs={12}>
                            {tabValue === 0 && (
                                <React.Fragment key="client_address_type1">
                                    <ClientAddressEdit onRef={(ref) => (this.child = ref)} addressType={1} clientId={clientId} classes={classes} />
                                </React.Fragment>
                            )}
                            {tabValue === 1 && (
                                <React.Fragment key="client_address_type2">
                                    <ClientAddressEdit onRef={(ref) => (this.child = ref)} addressType={2} clientId={clientId} classes={classes} />
                                </React.Fragment>
                            )}
                        </GridItem>
                    </GridContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.saveChild} color="primary">
                        <I18n trans="general:common.save" />
                    </Button>
                    <Button onClick={callBackClose} color="primary">
                        <I18n trans="general:common.close" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

ClientAddressesDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    clientId: PropTypes.number.isRequired,
};

export default ClientAddressesDialog;
